import { render, staticRenderFns } from "./ActivationBriefProductsRouterView.vue?vue&type=template&id=256c7edd&"
import script from "./ActivationBriefProductsRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProductsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports